import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import KinosLeadModal from '../components/LeadGen/KinosLeadModal';
import SaasHeroSection from '../components/Saas/SaasHeroSection';
import SaasCapabilitiesSection from '../components/Saas/SaasCapabilitiesSection';
import SaasHowItWorksSection from '../components/Saas/SaasHowItWorksSection';
import SaasIntegrationsSection from '../components/Saas/SaasIntegrationsSection';
import SaasFAQSection from '../components/Saas/SaasFAQSection';
import SaasGotQuestionsSection from '../components/Saas/SaasGotQuestionsSection';

const SaasHome = () => {
  const [demoModalOpen, setDemoModalOpen] = useState(false);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    if (window.location.hash) {
      const cleanUrl = `${window.location.pathname}${window.location.search}`;
      window.history.replaceState(null, '', cleanUrl);
    }
  }, []);

  useEffect(() => {
    const anchors = Array.from(document.querySelectorAll('a[href^="#"]'));
    const handlers = anchors.map((anchor) => {
      const handleClick = (e) => {
        e.preventDefault();
        const targetId = anchor.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 100,
            behavior: 'smooth',
          });
        }
      };
      anchor.addEventListener('click', handleClick);
      return { anchor, handleClick };
    });
    return () => {
      handlers.forEach(({ anchor, handleClick }) => {
        anchor.removeEventListener('click', handleClick);
      });
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <main className="flex-grow pb-20 sm:pb-0">
        <SaasHeroSection />
        <SaasCapabilitiesSection />
        <SaasHowItWorksSection />
        <SaasIntegrationsSection />
        <SaasFAQSection />
        <SaasGotQuestionsSection onBookDemo={() => setDemoModalOpen(true)} />
      </main>

      <KinosLeadModal
        open={demoModalOpen}
        onClose={() => setDemoModalOpen(false)}
        email=""
      />

      <Footer />

      <div className="fixed bottom-0 left-0 right-0 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] bg-white/40 backdrop-blur-md border-t border-gray-200/40 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] sm:hidden z-40">
        <a
          href="https://engagement.kolanut.ai/signup"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-full py-3.5 rounded-full bg-[#8ae690] text-black font-bold text-base shadow-lg hover:bg-[#7ad67f] active:scale-[0.98] transition-all duration-200"
        >
          Activate Your Growth Flywheel
        </a>
      </div>

      <style jsx global>{`
        html {
          scroll-behavior: smooth;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        section {
          animation: fadeIn 0.6s ease-out;
        }
        body {
          overflow-x: hidden;
        }
      `}</style>
    </div>
  );
};

export default SaasHome;
